import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const skeletonVariants = cva(
  'animate-pulse rounded-md bg-surface-active opacity-30',
  {
    variants: {
      variant: {
        default: 'bg-surface-active',
        'low-emphasis': 'bg-surface',
        translucent: 'bg-grayA-2',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Skeleton({
  className,
  variant = 'default',
  ...props
}: React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof skeletonVariants>) {
  return (
    <div className={cn(skeletonVariants({ variant }), className)} {...props} />
  );
}

export { Skeleton };
